import React from 'react';

import { FontAwesomeIcon, IconButton } from '@schoolinks/ui-components';

import cn from 'classnames';
import { bool, number, string, func } from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { faXmark } from '@fortawesome/pro-regular-svg-icons/faXmark';

import * as notificationActions from 'actions/notification';

import s from './Notification.css';

// @TODO Make Notifications Stackable
@connect(
  ({ notification }) => ({
    open: notification.open,
    text: notification.text,
    type: notification.type,
    dismissAfter: notification.timer,
  }),
  dispatch => bindActionCreators({ ...notificationActions }, dispatch),
)
class Notification extends React.Component {
  componentDidMount() {
    this.dismissAutomatically();
  }

  componentDidUpdate() {
    this.dismissAutomatically();
  }

  componentWillUnmount() {
    clearTimeout(this.dismissalTimer);
  }

  dismissAutomatically() {
    const { open, dismissAfter, hideNotification } = this.props;
    if (open && dismissAfter) {
      clearTimeout(this.dismissalTimer);
      this.dismissalTimer = setTimeout(() => {
        hideNotification();
      }, dismissAfter);
    }
  }

  render() {
    const { text, type = 'default', open, hideNotification } = this.props;
    return (
      <div
        className={cn(
          s.notificationBar,
          { [s.notificationDefault]: type === 'default' },
          { [s.notificationInfo]: type === 'info' },
          { [s.notificationWarning]: type === 'warning' },
          { [s.notificationError]: type === 'error' },
          { [s.show]: open },
        )}
      >
        <IconButton
          aria-label="Hide notification"
          className={s.closeButton}
          onClick={hideNotification}
        >
          <FontAwesomeIcon
            className={cn({ [s.lightIcon]: type !== 'default' })}
            icon={faXmark}
          />
        </IconButton>
        <p className={cn(s.text, { [s.lightText]: type !== 'default' })}>
          {text}
        </p>
      </div>
    );
  }
}

Notification.propTypes = {
  open: bool.isRequired,
  dismissAfter: number,
  type: string,
  text: string,
  hideNotification: func.isRequired,
};

Notification.defaultProps = {
  dismissAfter: 10000 * 5, // dismisses itself automatically after 5 seconds
  type: 'default',
  text: '',
};

export default connect()(Notification);
